import React, { FC } from 'react'
import { ID } from '@/_metronic/helpers'
import { useState, useEffect } from 'react'
import { TrxMsisdnData } from '../core/_models'
import { getTrxMsisdn } from '../core/_requests'
import { DonutCard } from './DonutCard'
import { useIntl } from 'react-intl'

type Props = {
  userId?: ID
  from: Date
  to: Date
  height: number
  paymode?: string
  timezone: string;
}


const TrxCarrierChart: FC<Props> = ({ userId, from, to, height, paymode, timezone }) => {
  const [data, setData] = useState<Array<TrxMsisdnData>>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const intl = useIntl()

  useEffect(() => {
    const load = async () => {
      try {
        setIsLoading(true)
        const res = await getTrxMsisdn({ from, to, userId, paymode, timezone })

        setData(res || [])
      } catch (e: unknown) {
        console.log(e)
      } finally {
        setIsLoading(false)
      }
    }
    load()
  }, [userId, from, to, paymode])

  return (
    <DonutCard<TrxMsisdnData>
      id="msisdn-type"
      title={
        <>
          Phones types
          {paymode && (
            <i className="text-danger ms-1">
              {intl.formatMessage({ id: `P2C.PAYMODE_${paymode.toUpperCase()}` })}
            </i>
          )}
        </>
      }

      height={height}
      isLoading={isLoading}
      data={data}
      showAggs={true}
      getLabel={(item) => item.category}
      getAggValue={(item, agg) => Number(item[agg as keyof TrxMsisdnData]) || 0}
    />
  )
}

export default TrxCarrierChart
